export default [{
        path: '/',
        name: 'home',
        component: () => import('./views/home'),
    },
    {
        path: '/video/1128',
        name: 'video',
        component: () => import('./views/other/video'),
    },
    {
        path: '/survey/:serviceId',
        name: 'survey',
        props: true,
        component: () => import('./views/orders/survey'),
    },
    {
        path: '/higg-form',
        name: 'order-higg-form',
        component: () => import('./views/orders/higg-form'),
    },
    {
        path: '/higg-form/:sales',
        name: 'order-higg-sales-form',
        props: true,
        component: () => import('./views/orders/higg-form'),
    },
    {
        path: '/slcp-form',
        name: 'order-slcp-form',
        component: () => import('./views/orders/slcp-form'),
    },
    {
        path: '/slcp-form/:sales',
        name: 'order-slcp-sales-form',
        props: true,
        component: () => import('./views/orders/slcp-form'),
    },
    {
        path: '/wrap-form',
        name: 'order-wrap-form',
        component: () => import('./views/orders/wrap-form'),
    },    
    {
        path: '/wrap-form/:sales',
        name: 'order-wrap-sales-form',
        props: true,
        component: () => import('./views/orders/wrap-form'),
    },    
    {
        path: '/general-form',
        name: 'order-general-form',
        component: () => import('./views/orders/general-form'),
    },
    {
        path: '/general-form/:sales',
        name: 'order-general-sales-form',
        props: true,
        component: () => import('./views/orders/general-form'),
    },
    {
        path: '/aws-form',
        name: 'order-aws-form',
        component: () => import('./views/orders/aws-form'),
    },
    {
        path: '/aws-form/:sales',
        name: 'order-aws-sales-form',
        props: true,
        component: () => import('./views/orders/aws-form'),
    },    
    {
        path: '/zero-level2-form',
        name: 'order-zero-level2-form',
        component: () => import('./views/orders/zero-level2-form'),
    },
    {
        path: '/zero-level2-form/:sales',
        name: 'order-zero-level2-form-sales',
        props: true,
        component: () => import('./views/orders/zero-level2-form'),
    },    
    {
        path: '/zdhc-level1-form',
        name: 'order-zdhc-level1-form',
        component: () => import('./views/orders/zdhc-level1-form'),
    },
    {
        path: '/zdhc-level1-form/:sales',
        name: 'order-zdhc-level1-form-sales',
        props: true,
        component: () => import('./views/orders/zdhc-level1-form'),
    },    
    {
        path: '/ghg-form',
        name: 'order-ghg-form',
        component: () => import('./views/orders/ghg-form'),
    },
    {
        path: '/ghg-form/:sales',
        name: 'order-ghg-form-sales',
        props: true,
        component: () => import('./views/orders/ghg-form'),
    },       
    {
        path: '/follow-up-audit',
        name: 'order-follow-up-audit',
        component: () => import('./views/orders/follow-up-audit'),
    },
    {
        path: '/follow-up-audit/:sales',
        name: 'order-follow-up-audit-sales',
        props: true,
        component: () => import('./views/orders/follow-up-audit'),
    },      
    {
        path: '/invoice/:orderNo',
        name: 'invoice',
        props: true,
        component: () => import('./views/orders/invoice'),
    },
    {
        path: '/application-confirm/:orderNo',
        name: 'application-confirm',
        props: true,
        component: () => import('./views/other/application-confirm'),
    },
    {
        path: '/confirm-letter/:serviceId',
        name: 'confirm-letter',
        props: true,
        component: () => import('./views/other/confirm-letter'),
    },
    {
        path: '/service-file-upload/:serviceId',
        name: 'service-file-upload',
        props: true,
        component: () => import('./views/other/service-file-upload'),
    },
    {
        path: '/share-file/:shareId',
        name: 'share-file',
        props: true,
        component: () => import('./views/other/share-file'),
    },
    {
        path: '/traning-survey/:traningCode',
        name: 'traning-survey',
        props: true,
        component: () => import('./views/orders/traning-survey'),
    },
]